export enum difficultyEnum {
    unset = "Unset",
    normal = "Normal",
    hard = "Hard",
    hell = "Hell",
}

export const difficultyTimeMap: Record<difficultyEnum, number> = {
    [difficultyEnum.unset]: 0, // Assuming 'unset' has no time or a default time of 0
    [difficultyEnum.normal]: 40,
    [difficultyEnum.hard]: 25,
    [difficultyEnum.hell]: 15,
};

export const difficultyIndex: Record<difficultyEnum, number> = {
    [difficultyEnum.unset]: 0, // Assuming 'unset' has no time or a default time of 0
    [difficultyEnum.normal]: 1,
    [difficultyEnum.hard]: 2,
    [difficultyEnum.hell]: 3,
};